// extracted by mini-css-extract-plugin
export default {"aside":"management-console_aside__MgBr-","menu":"management-console_menu__DDR5d"};